export default __webpack_public_path__ + "outlaw_background-details-mobile.5f6cb5.svg";